<template>
  <!-- 테스트 채팅 플로팅 위젯 (우하단 fixed 버튼 + 채팅 다이얼로그) — 자족형.
       선택 펫의 pub 소켓으로 CHAT/DONATION requestCommand를 쏴서 온에어/미리보기 반응을 테스트.
       (구 LiveRemotePage 내장분을 추출 — 아무 페이지에나 <TestChatWidget/> 한 줄로 사용) -->
  <FixedChattingPanel>
    <template>
      <ChzzkChattingPanel
        ref="panel"
        @onUserInput="onUserInput"
        @on="onChat"
        @donation="onDonation"
      ></ChzzkChattingPanel>
    </template>
  </FixedChattingPanel>
</template>

<script>
import SupabaseApi from "@/api/SupabaseApi";
import { getVirtupetPubSocket } from "@/domain/stream/pub/VirtupetPubSocket";

export default {
  name: "TestChatWidget",
  async created() {
    // 제어 라우팅 키 = 선택 펫 id. 펫 단위 pub 인스턴스는 전역 공유(getVirtupetPubSocket) — 페이지와 결합 없음.
    try {
      const petId = await SupabaseApi.UserStatus.fetchSelectedPetId();
      if (petId) this._socket = getVirtupetPubSocket(petId).socket;
    } catch (e) {
      console.warn("[TestChatWidget] pub 소켓 초기화 실패", e);
    }
  },
  methods: {
    // 입력창 → 패널에 로컬 echo
    onUserInput(message) {
      const oneChat = { isFan: true, name: "테스트 사용자", color: "rgb(225, 100, 144)", message, modifiedMessage: message };
      if (this.$refs.panel) this.$refs.panel.appendMessage(oneChat);
    },
    // 채팅 전송 → 게이트웨이 fan-out (온에어/미리보기가 반응)
    onChat(chat) {
      if (!this._socket) return;
      this._socket.emit("requestCommand", {
        type: "CHAT",
        to: "liveModel",
        message: chat.message,
        hidden: false,
        profile: { nickname: chat.name || "테스트" },
      });
    },
    onDonation(donation) {
      if (!this._socket) return;
      this._socket.emit("requestCommand", { type: "DONATION", to: "liveModel", ...donation });
    },
  },
};
</script>
